<template>
    <div id="header" v-if="portal">
        <b-container>
            <b-link :href="portal.companyLink ? portal.companyLink : 'https://www.inpart.io/'" target="_blank">
                <b-img class="inova-logo" :src="portal.logoUrl ? portal.logoUrl : `${publicPath}assets/images/inpart-logo.png`"></b-img>
            </b-link>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: "Header",
        props: {
            portal: Object
        },
        data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },
    }
</script>

<style lang="scss" scoped>
    #header {
        background: #ffffff;
    }

    .inova-logo {
        margin: 20px 0;
        max-height: 40px;
    }

    #navigation {
        background: var(--primary);
    }
</style>